<template>
  <div class="text-editor-content" v-html="html" v-linkified></div>
</template>

<script>
import { Storage } from "aws-amplify";
import aws_exports from "@/aws-exports";

export default {
  props: {
    s3Url: {
      type: String,
    },
    needsRefresh: {
      type: String,
    },
  },
  data() {
    return {
      html: '',
    };
  },
  mounted() {
    this.getComment();
  },
  watch: {
    /**
     * The S3 Key of the comment file
     * Whenever URL changes - fetch latest content
     */
    s3Url: {
      immediate: true,
      handler: function () {
        this.getComment();
      },
    },
    /**
     * This is used to get the latest HTML content
     * Just update the refresh prop in the comment and this event will be triggerd
     */
    needsRefresh: {
      immediate: true,
      handler: function () {
        this.$emit('refresh', this.html);
      },
    }
  },
  methods: {
    /**
     * Get latest HTML content from S3 and emit refresh event
     * @returns {Void}
     */
    async getComment() {
      this.html = await this.getCommentHtml();
      this.$emit('refresh', this.html);
    },
    /**
     * Get the comment file from S3 and return as HTML
     * @returns {string} the comment HTML
     */
    async getCommentHtml() {
      if (!this.s3Url) {
        return '';
      }
      let error = null;
      const data = await Storage.get(this.s3Url, {
        download: true,
        bucket: aws_exports.aws_user_files_s3_bucket,
        region: aws_exports.aws_user_files_s3_bucket_region,
      }).catch((err) => (error = err));
      if (error) {
        return '';
      }
      return data.Body.toString();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>